import React from "react";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
// import AccountTree from "@material-ui/icons/AccountTree";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
// import PeopleIcon from "@material-ui/icons/People";
// import ForumIcon from '@material-ui/icons/Forum';
import { AccountTree, AlarmOn } from '@material-ui/icons';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import ToolsIcon from '@mui/icons-material/Handyman';
import SmsIcon from '@mui/icons-material/Sms';
import ChatBubble from '@mui/icons-material/ChatBubble';
import PaidIcon from '@mui/icons-material/Paid';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import GroupsIcon from '@mui/icons-material/Groups';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
// import InsightsIcon from '@mui/icons-material/Insights';
import FactoryIcon from '@mui/icons-material/Factory';

export const MenuCategories = {
  admin: {
    id: 'admin',
    name: 'مدیریت',
    icon: <VerifiedUserIcon />,
  },
  notifications: {
    id: 'notifications',
    name: ' اعلان ها',
    icon: <AlarmOn />,

  },
  need: {
    id: 'need',
    name: ' درخواست ها',
    icon: <AlarmOn />,

  },
  transaction: {
    id: 'transaction',
    name: ' تراکنش‌ها ',
    icon: <PaidIcon />,

  },
  reportInsert: {
    id: 'reportInsert',
    name: 'ثبت موجودی',
    icon: <KeyboardArrowUpIcon />,
  },
  reportProductionInsert: {
    id: 'reportProductionInsert',
    name: 'ثبت تولید',
    icon: <KeyboardArrowUpIcon />,
  },
  reportInputProductInsert: {
    id: 'reportInputProductInsert',
    name: 'ثبت انبار ورودی',
    icon: <KeyboardArrowUpIcon />,
  },
  report: {
    id: 'report',
    name: 'گزارش موجودی',
    icon: <KeyboardArrowUpIcon />,
  },
  chat: {
    id: 'chat',
    name: 'گفتگو داخلی',
    icon: <ChatBubble />,
  },
  crm: {
    id: 'crm',
    name: 'ارتباط مشتریان',
    icon: <SupportAgentIcon />,
    initialOpen: true,
  },
  customer: {
    id: 'customer',
    name: 'مشتریان',
    icon: <GroupsIcon />,
  },
  contact: {
    id: 'contact',
    name: 'مخاطبان',
    icon: <ContactPhoneIcon />,

  },
  clue: {
    id: 'clue',
    name: 'سرنخ‌ها',
    icon: <SavedSearchIcon />,

  },

  loading: {
    id: 'loading',
    name: 'سفارش بار',
    icon: <LocalShippingIcon />,
  },
  reminder: {
    id: 'reminder',
    name: 'یادآوری',
    icon: <AccessAlarmsIcon />,
  },
  tools: {
    id: 'tools',
    name: 'ابزارها',
    icon: <ToolsIcon />,
    initialOpen: true,

  },
  prod: {
    id: 'prod',
    name: 'محصولات',
    icon: <SpeakerNotesIcon />,
  },
  res: {
    id: 'res',
    name: 'نیاز سیستم',
    icon: <KeyboardArrowUpIcon />,
    initialOpen: false

  },
  rescrm: {
    id: 'rescrm',
    name: 'نیاز بخش مشتریان',
    icon: <SupportAgentIcon />,
  },
  sendSMS: {
    id: 'sendSMS',
    name: 'ارسال گروهی',
    icon: <SmsIcon />,

  },
  whatsapp: {
    id: 'whatsapp',
    name: 'واتس اپ',
    icon: <BubbleChartIcon />,
  },
  branch: {
    id: 'branch',
    name: 'شعبه',
    icon: <AccountTree />,

  },
  event: {
    id: 'event',
    name: '  رخداد',
    icon: <AlarmOn />,

  },
  storage: {
    id: 'storage',
    name: 'مخزن',
    icon: <AccountTree />,
  },
  bi: {
    id: 'bi',
    name: ' تحلیل‌ها',
    icon: <BubbleChartIcon />
  },
  productCapacity: {
    id: 'productCapacity',
    name: 'ظرفیت تولید',
    icon: <BubbleChartIcon />
  },
  production: {
    id: 'production',
    name: 'تولید',
    icon: < FactoryIcon style={{ color: "#0eda41" }} />
  }

}

export const MenuIsOpenState = {
  adminUsers: false,
}
